import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'
import type { LandingPageSharedDataRawData } from '@/Shared/AutoGenerated/Main'

export default class LandingPageSharedData {
    constructor(
        public readonly appName: string,
        public readonly openCookieSettingsElementId: string,
    ) {
        ensureNoUndefinedProperties(this)
    }

    static hydrate(
        rawData: LandingPageSharedDataRawData,
    ): LandingPageSharedData {
        return new LandingPageSharedData(
            rawData.appName,
            rawData.openCookieSettingsElementId,
        )
    }

    getLandingPageLayoutProps() {
        return {
            appName: this.appName,
            openCookieSettingsElementId: this.openCookieSettingsElementId,
        }
    }
}
